
export default {
  props: {
    val: {
      // 评分数值
      type: [Number, String],
      default: 0
    },
    stylerow: {
      // true排列横排，false竖排
      type: Boolean,
      default: true
    },
    textshow: {
      // 文本是否显示
      type: Boolean,
      default: true
    }
  }
}
